<template>
  <v-edit-dialog :return-value.sync="inputValue" large persistent>
    <v-img
      height="48"
      width="48"
      :alt="altText || 'Opponent Logo'"
      :src="inputValue || '/default-img.png'"
      class="rounded-sm"
    />
    <template v-slot:input>
      <div class="py-4">
        <!-- <label class="grey--text text--darken-1">Page Sponsor Image</label> -->
        <upload-image
          :value="inputValue"
          height="200"
          width="200"
          :fileUrl="inputValue"
          @input="onInput"
          key="2"
          class="mb-5 mt-2"
        />
        <!-- :client-id="program.clientId" -->
      </div>
    </template>
  </v-edit-dialog>
</template>

<script lang="ts">
  import UploadImage from '@/components/Ui/UploadImage.vue';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'opponentLogoImg',
    components: { UploadImage },
    props: {
      value: {
        type: String,
        default: '',
      },
      altText: {
        default: '',
      },
    },
    data() {
      return {
        inputValue: this.value,
        inputAltText: this.altText,
      };
    },
    methods: {
      onInput(e: string) {
        this.inputValue = e;
        this.$emit('input', this.inputValue);
      },
    },
  });
</script>
